import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

const BASE = "/Store/MaterialRequisition";

export const GetAllMaterialRequisitionsApi = async (projectId, status) => {
  try {
    const params = new URLSearchParams();
    if (projectId) {
      params.set("projectId", projectId);
    }
    if (status) {
      params.set("status", status);
    }
    const query = params.toString() ? `?${params.toString()}` : "";
    const response = await axiosInstance.get(`${BASE}/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetMaterialRequisitionByIdApi = async (id) => {
  try {
    const response = await axiosInstance.get(`${BASE}/GetById/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddMaterialRequisitionApi = async (formData) => {
  try {
    const response = await axiosInstanceForm.post(`${BASE}/Create`, formData);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const EditMaterialRequisitionApi = async (id, formData) => {
  try {
    const response = await axiosInstanceForm.put(`${BASE}/Edit/${id}`, formData);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeleteMaterialRequisitionApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BASE}/Delete/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateMaterialRequisitionApprovalApi = async (approvalId, status, comments) => {
  try {
    const url = `${BASE}/UpdateApproval/${approvalId}?status=${encodeURIComponent(status)}&comments=${encodeURIComponent(comments || "")}`;
    const response = await axiosInstance.put(url);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const CancelMaterialRequisitionRemainderApi = async (id, body) => {
  try {
    const response = await axiosInstance.post(`${BASE}/CancelRemainder/${id}`, body);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
